import React from "react";

export function ReportError({ message, onRetry }) {
  return (
    <div className="dashboard-error">
      <p>{message || "Something went wrong loading this data."}</p>
      {onRetry && (
        <button type="button" className="btn btn-sm btn-light-primary" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}

export function ReportLoading() {
  return (
    <div className="dashboard-empty">
      <div className="spinner-border text-primary spinner-border-sm" role="status">
        <span className="sr-only">Loading&hellip;</span>
      </div>
    </div>
  );
}

export function ReportEmpty({ message }) {
  return <div className="dashboard-empty">{message || "Nothing to show yet."}</div>;
}
